import { render, staticRenderFns } from "./Backups.vue?vue&type=template&id=64db65bc&"
import script from "./Backups.vue?vue&type=script&lang=ts&"
export * from "./Backups.vue?vue&type=script&lang=ts&"
import style0 from "./Backups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports